export default {"src":"/_next/static/media/recycleable.99f77013.svg","height":16,"width":16};